import Base from './Base'

export default class Option extends Base {
    type = 'option';
    
    toJSON = () => {
        let me = this, _this = {};
        ['_id', 'ref_id', 'parent', 'type', 'name', 'price', 'originalPrice', 'new', 'delete', 'show'].map((prop) => { _this[prop] = me[prop]; });
        return _this;
    }
}